export default __webpack_public_path__ + "static/media/dollarCircle.f26616b5.svg";